export default __webpack_public_path__ + "static/media/kitchen.c35616f8.jpg";